import { ScheduledOfferModal } from '@/components/ScheduledOfferModal';
import { useMonthlyOffer } from '@/contexts/MonthlyOfferContext';
import { usePayment } from '@/hooks/usePayment';
import { useAvailablePaymentMethods } from '@/hooks/useAvailablePaymentMethods';

interface ScheduledOffer {
  id: number;
  title: string;
  gc_amount: number;
  sc_amount: number;
  gc_bonus_amount: number;
  sc_bonus_amount: number;
  price: number;
  original_price: number | null;
  cadence_type: string;
  resets_at: string | null;
  can_purchase: boolean;
  purchases_remaining: number;
  group_id: number | null;
  is_welcome_offer: boolean;
}

export const GlobalMonthlyOfferModal = () => {
  const { 
    showMonthlyOfferModal, 
    setShowMonthlyOfferModal,
    currentMonthlyOffer,
    currentMonthlyGroup,
    hasMoreMonthlyOffers,
    dismissCurrentOffer,
  } = useMonthlyOffer();
  const { openPayment } = usePayment();
  const { coinflowOnly } = useAvailablePaymentMethods();

  const handlePurchase = async (offer: ScheduledOffer) => {
    setShowMonthlyOfferModal(false);
    
    await openPayment(
      {
        id: offer.id.toString(),
        title: offer.title,
        price: offer.price,
        originalPrice: offer.original_price ?? undefined,
        gcAmount: offer.gc_amount,
        scAmount: offer.sc_amount,
        gcBonusAmount: offer.gc_bonus_amount,
        scBonusAmount: offer.sc_bonus_amount,
        isScheduledOffer: true,
        coinflowOnly,
      },
      {
        onSuccess: () => {
          dismissCurrentOffer();
        },
        onBack: () => {
          setShowMonthlyOfferModal(true);
        },
      }
    );
  };

  const handleClose = () => {
    dismissCurrentOffer();
  };

  return (
    <ScheduledOfferModal
      isOpen={showMonthlyOfferModal}
      onClose={handleClose}
      offer={currentMonthlyOffer}
      offerGroup={currentMonthlyGroup}
      hasMoreOffers={hasMoreMonthlyOffers}
      onPurchase={handlePurchase}
      theme="monthly"
    />
  );
};
